module.exports = __webpack_public_path__ + "static/media/huangyouming.5141d44d.png";